import { render, staticRenderFns } from "./YourImpactPreferences.vue?vue&type=template&id=15385348&scoped=true&"
import script from "./YourImpactPreferences.vue?vue&type=script&lang=js&"
export * from "./YourImpactPreferences.vue?vue&type=script&lang=js&"
import style0 from "./YourImpactPreferences.vue?vue&type=style&index=0&id=15385348&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15385348",
  null
  
)

export default component.exports